import React, {PropTypes} from 'react';
import { FormGroup, ControlLabel, Button, Row, Col, Modal, HelpBlock } from 'react-bootstrap';
import Classnames from 'classnames';

export default class CreateSubscriptionSuccessModal extends React.Component {

  handleCancel(){
    this.props.onCancel()
  }

  render() {
    const { showModal, modalTitle, content, buttonTitle } = this.props

    const btnInlineStyle =   {
        width: "100%",
        height: "45px",
        fontSize: "18px"
    }
    const fullWidth = {
        width: "100% ",
        textAlign: "center",
        fontSize: "18px"
    }

    return (
      <div className="subscription-form-box">
        <Modal bsSize="small" show={showModal} onHide={this.handleCancel.bind(this)} dialogClassName="custom-modal" >
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={ 12 } sm={ 12 }>
                <FormGroup controlId="stripe-form-total">
                  <div className="full-width-center-text" style={fullWidth}>
                    Please close and re-open the app on your phone to see your account status update to Premium.
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={ 12 } sm={ 12 }>
                <FormGroup controlId="stripe-form-total">
                  <div className="full-width-center-text" style={fullWidth}>
                    Thank you!
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <div className="full-width-center-text" style={fullWidth}>
                <Button onClick={this.handleCancel.bind(this)} className="btn-main-green" style={btnInlineStyle} type="submit">
                  {buttonTitle}
                </Button>
              </div>
            </Row>

          </Modal.Body>
        </Modal>

      </div>
    );
  }
}

CreateSubscriptionSuccessModal.propTypes = {
};



// WEBPACK FOOTER //
// ./src/subscriptions/CreateSubscriptionSuccessModal.js